import { ReactNode } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Typography } from 'amo-styling-library'
import { useAuth } from '../../contexts/AuthContext'
import { HomeIcon, RocketIcon, BoxIcon, EnvelopeClosedIcon, PersonIcon } from '@radix-ui/react-icons'

interface SimpleDashboardLayoutProps {
  children: ReactNode
}

export const SimpleDashboardLayout = ({ children }: SimpleDashboardLayoutProps) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { logout, user } = useAuth()

  const isActive = (path: string) => {
    if (path === '/containers/expected') {
      return location.pathname.startsWith('/containers')
    }
    return location.pathname === path || location.pathname.startsWith(path + '/')
  }

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <div className="flex flex-col h-screen">
      {/* Top Bar */}
      <div className="h-[88px] flex bg-white border-b">
        <div className="w-64 flex items-center justify-center px-8">
          <img
            src="/cropped-cropped-LOGO1-2.png"
            alt="LDH TRANS"
            className="h-[68px] w-auto"
          />
        </div>
        <div className="flex-1 flex items-center justify-end px-8" style={{ background: '#DA0000' }}>
          <div className="flex items-center gap-3">
            <Typography variant="body2" className="text-white font-medium">
              {user?.firstName} {user?.lastName}
            </Typography>
            <button
              onClick={handleLogout}
              className="px-4 py-2 border border-white text-white text-sm rounded hover:bg-white hover:text-red-600"
            >
              Uitloggen
            </button>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <div className="flex flex-1 overflow-hidden">
        <nav className="w-64 bg-white border-r border-gray-200 p-4">
          <div className="space-y-1">
            <button
              onClick={() => navigate('/start')}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors font-medium ${
                isActive('/start')
                  ? 'bg-red-50 text-red-600'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              <HomeIcon width={20} height={20} />
              <span>Start</span>
            </button>
            <button
              onClick={() => navigate('/import-export')}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors font-medium ${
                isActive('/import-export')
                  ? 'bg-red-50 text-red-600'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              <RocketIcon width={20} height={20} />
              <span>Import / Export</span>
            </button>
            <button
              onClick={() => navigate('/containers/expected')}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors font-medium ${
                isActive('/containers/expected')
                  ? 'bg-red-50 text-red-600'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              <BoxIcon width={20} height={20} />
              <span>In Stock</span>
            </button>
            <button
              onClick={() => navigate('/inbox')}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors font-medium ${
                isActive('/inbox')
                  ? 'bg-red-50 text-red-600'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              <EnvelopeClosedIcon width={20} height={20} />
              <span>Inbox</span>
            </button>
            <button
              onClick={() => navigate('/sync')}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors font-medium ${
                isActive('/sync')
                  ? 'bg-red-50 text-red-600'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              <HomeIcon width={20} height={20} />
              <span>Synchronisatie</span>
            </button>
            <button
              onClick={() => navigate('/user-management')}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors font-medium ${
                isActive('/user-management')
                  ? 'bg-red-50 text-red-600'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              <PersonIcon width={20} height={20} />
              <span>Gebruikersbeheer</span>
            </button>
          </div>
        </nav>

        {/* Main Content */}
        <div className="flex-1 p-6 overflow-auto bg-gray-100">
          {children}
        </div>
      </div>
    </div>
  )
}
